export const searchedAction = (type, str) => {
    return{
        type: type,
        stringa: str
    }
}